var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.432,
    height: 20,
    viewBox: "0 0 15.432 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f7c54c413a8467af4b34ad6c6e217e1f",
    d: "M12.886,13.761A3.934,3.934,0,0,0,16.1,12.087c.006-.008.016-.012.022-.02l.007-.016a3.938,3.938,0,1,0-3.243,1.709Zm2.889-3.942a2.871,2.871,0,0,1-.258,1.186L13.412,9.543V6.982A2.891,2.891,0,0,1,15.775,9.819ZM12.359,6.982V9.819a.526.526,0,0,0,.226.432l2.331,1.62a2.887,2.887,0,1,1-2.557-4.888ZM8.3,16.024a.526.526,0,0,1,.526-.526h4.059a.526.526,0,0,1,0,1.053H8.827A.526.526,0,0,1,8.3,16.024Zm9.171,1.895a.526.526,0,0,1-.526.526H8.827a.526.526,0,0,1,0-1.053h8.118a.526.526,0,0,1,.526.522Zm0,1.895a.526.526,0,0,1-.526.526H8.827a.526.526,0,0,1,0-1.053h8.118a.526.526,0,0,1,.526.518ZM20.561,6.462a.533.533,0,0,0-.115-.173L17.323,3.157a.5.5,0,0,0-.172-.116.526.526,0,0,0-.2-.041H6.749A1.579,1.579,0,0,0,5.17,4.579V21.421A1.579,1.579,0,0,0,6.749,23H19.023A1.579,1.579,0,0,0,20.6,21.421V6.663a.505.505,0,0,0-.041-.2ZM17.475,4.8l1.333,1.337H18a.526.526,0,0,1-.526-.526Zm1.547,17.147H6.749a.526.526,0,0,1-.526-.526V4.579a.526.526,0,0,1,.526-.526h9.674V5.611A1.579,1.579,0,0,0,18,7.189h1.547V21.421A.526.526,0,0,1,19.023,21.947Z",
    transform: "translate(-5.17 -3)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.da198cd25e1eccd5b941d90cb5e581da.svg";
export { ForwardRef as ReactComponent };